import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from '@tanstack/react-router';
import { ClerkProvider, useAuth } from '@clerk/clerk-react';
import { ConvexProviderWithClerk } from 'convex/react-clerk';
import { convex } from '@/lib/convex';
import { clerkAppearance, clerkLocalization } from '@/lib/clerk-appearance';
import App from '@/App';
import './index.css';

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!clerkKey) throw new Error('VITE_CLERK_PUBLISHABLE_KEY is not set');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

// Clerk navigates through the router's history, so its steps never reload the page.
const history = createBrowserHistory();

createRoot(rootElement).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={clerkKey}
      appearance={clerkAppearance}
      localization={clerkLocalization}
      signInUrl="/sign-in"
      waitlistUrl="/waitlist"
      routerPush={(to) => history.push(to)}
      routerReplace={(to) => history.replace(to)}
    >
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <App history={history} />
      </ConvexProviderWithClerk>
    </ClerkProvider>
  </StrictMode>
);
